import { lazy } from 'react';

const Status = {
  NotFound: lazy(() => import('./pages/NotFound')),
  Forbidden: lazy(() => import('./pages/Forbidden')),
  Maintenance: lazy(() => import('./pages/Maintenance')),
};

export default Status;
